const verticalProfileOffsets = {
  SE0010: 30,
  SE0020: 22.7,
  SE0180: 24.7,
  SEXXXX20: 24.7,
};

export default verticalProfileOffsets;
